// extracted by mini-css-extract-plugin
export default {"container":"ServiceCard_container__q+hFD","title":"ServiceCard_title__ozNLI"};